import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import auth, { authSaga } from './auth';
import editor, { editorSaga } from './editor';

const rootReducer = combineReducers({
	auth,
	editor
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;

export function* rootSaga() {
	yield all([authSaga(), editorSaga()]);
}